var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg220Mall3Volt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 6,
    fill: "#BE69C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2676 47.1754C55.7111 38.7319 55.7111 25.0625 47.2676 16.6406",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.733 16.6406C8.28952 25.0841 8.28952 38.7535 16.733 47.1754",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.873 52.2285C27.1837 53.0275 29.5806 53.4163 31.9992 53.4163C34.4178 53.3947 36.8148 53.0275 39.1254 52.2285",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.873 11.5877C27.1837 10.7887 29.5806 10.3999 31.9992 10.3999C34.4178 10.3999 36.8148 10.7887 39.1254 11.5877",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2223 18.1519H44.9824V24.6313C44.9824 26.1432 45.7953 26.4492 46.7868 25.3153L53.5486 17.5759C54.3793 16.631 54.0309 15.8481 52.7714 15.8481H50.0113V9.36867C50.0113 7.8568 49.1985 7.55083 48.207 8.68473L41.4452 16.424C40.6234 17.378 40.9718 18.1519 42.2223 18.1519Z",
    fill: "#F7E237"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4998 39.16C25.5131 39.16 24.5531 39.0067 23.6198 38.7C22.6998 38.3933 21.9464 37.98 21.3598 37.46L22.2798 35.88C22.7464 36.32 23.3531 36.68 24.0998 36.96C24.8464 37.24 25.6464 37.38 26.4998 37.38C27.5398 37.38 28.3464 37.16 28.9198 36.72C29.5064 36.2667 29.7998 35.66 29.7998 34.9C29.7998 34.1667 29.5198 33.58 28.9598 33.14C28.4131 32.6867 27.5398 32.46 26.3398 32.46H25.2198V31.06L29.3798 25.94L29.6598 26.74H21.9998V25H31.2398V26.36L27.0998 31.46L26.0598 30.84H26.7198C28.4131 30.84 29.6798 31.22 30.5198 31.98C31.3731 32.74 31.7998 33.7067 31.7998 34.88C31.7998 35.6667 31.6064 36.3867 31.2198 37.04C30.8331 37.6933 30.2464 38.2133 29.4598 38.6C28.6864 38.9733 27.6998 39.16 26.4998 39.16ZM37.1684 39L32.5284 28.4H34.5284L38.6484 38H37.6884L41.8884 28.4H43.7684L39.1284 39H37.1684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg220Mall3Volt);
export default __webpack_public_path__ + "static/media/220mall_3volt.ccf43f179db0ce1ce8c697b61ca0254c.svg";
export { ForwardRef as ReactComponent };